import * as React from "react";


interface ISAMLAutherProps {
    domain: string
    clientId: string
}

// TODO This component is deprecated and should no longer be used.
export class SAMLAuther extends React.Component<ISAMLAutherProps> {
    iframe: HTMLIFrameElement | null;

    render() {
        const {domain, clientId} = this.props;
        const authUrl = `https://${domain}/samlp/${clientId}`;
        return (
            <div>
                <iframe src={authUrl} style={{display: "none"}} ref={(node) => this.iframe = node} />
            </div>
        );
    }
}